import {React, useState, useEffect} from 'react';
import '../../App.css'
import {Grid,Box, Button, Paper, Stack, FormControl, InputLabel, Select, MenuItem,FormHelperText,Typography} from '@mui/material';
import { ArrowForwardIos, ImportExport, Download} from '@mui/icons-material';
import { SiMicrosoftexcel } from "react-icons/si";
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

const initialFValues={
  id: 0,
  tableName: '',
  filePath: '',
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' }}>*</span>
  </span>
);

function DataManager(){

  const [values, setValues] = useState(initialFValues);
  const [fileData, setFileData] = useState();
  const [tableList, setTableList] = useState([]);
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const validate = () => {
    let temp = {}
    temp.tableName = values.tableName ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  function handleFileChange(e) {
    setFileData(e.target.files[0]);
  }

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
  }

  useEffect(() => {
    (async() => {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data-import/get-table-names`);
    const responseData = await response.json();
    if(response.status === 200) {
      setTableList(responseData.tableList);
    }
    })();
  }, []);
  
  const handleDownloadHeader = async () => {
    if(validate()) {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data-import/download-header/${values.tableName}`);
      
      response.blob().then((blob) => {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${values.tableName}.xlsx`;
        a.click();
      })

      // fetch(``${process.env.REACT_APP_API_BASE_URL}/data-import/download-header/${values.tableName}`)
      // .then((res) => res.blob())
      // .then((blob) => URL.createObjectURL(blob))
      // .then((href) => {
      //   Object.assign(document.createElement('a'), {
      //     href,
      //     download: 'filename.xlsx',
      //   }).click();
      // });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(validate()) {
      const data = new FormData();
      data.append('excel', fileData);
      data.append('table_name', values.tableName);
      let response;

      try {
        response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data-import/insert-excel-table`, {
          method: 'POST',
          body: data,
        });
        const responseData = await response.json();
  
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: responseData.message,
            type: 'success',
          });
        } else {
          setNotify({
            isOpen: true,
            message: responseData.error_message.sqlMessage,
            type: 'error',
          });
        }
      } catch (e) {
        if(response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error',
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper variant="outlined" elevation={5} >
        <Grid className="form-title" container spacing={1}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Import Data from Excel</Typography> </Grid>
          <Grid item> <SiMicrosoftexcel size='45px' style={{color: 'green'}}/> </Grid>
          <Grid item> <ImportExport sx={{width: 45, height: 45}}/> </Grid>
          
        </Grid>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{margin: "30px"}}>

            <FormControl
              variant='outlined'
              { ...(errors.tableName && {error: true}) }>
              <InputLabel><RequiredLabel label="Table Name"></RequiredLabel></InputLabel>
              <Select
                label= "Table name"
                size='small'
                name='tableName'
                value={values.tableName}
                onChange={handleInputChange}
              >
                <MenuItem value="">None</MenuItem>
                {
                  tableList.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)
                }
              </Select>
              {errors.tableName && <FormHelperText>{errors.tableName}</FormHelperText>}
            </FormControl>

            <Button 
              sx={{width: '100%'}}
              variant="contained"
              endIcon={<Download />}
              onClick={handleDownloadHeader}
              color='error'
              disableElevation
            >
              Download Header
            </Button>

            <div class="mb-3">
              <label for="formFile" class="form-label">Select a file:</label>
              <input name="filePath" class="form-control" type="file" id="formFile" onChange={handleFileChange} required/>
            </div>


            <Stack display="flex" sx={{alignItems: "flex-end"}}>
                <Button variant="contained" endIcon={<ArrowForwardIos />} type="submit" disableElevation>Save</Button>
            </Stack>

            </Stack>
            {/* <input type="file" onChange={handleFileChange} />
            <button type="submit">Submit</button> */}
        </form>
      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default DataManager;
